import { render, staticRenderFns } from "./listing-product-item.vue?vue&type=template&id=88c2f4f4&"
import script from "./listing-product-item.vue?vue&type=script&lang=js&"
export * from "./listing-product-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cinderellamaecuya/SP/peppermayo-astro/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88c2f4f4')) {
      api.createRecord('88c2f4f4', component.options)
    } else {
      api.reload('88c2f4f4', component.options)
    }
    module.hot.accept("./listing-product-item.vue?vue&type=template&id=88c2f4f4&", function () {
      api.rerender('88c2f4f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/listing-product-item.vue"
export default component.exports